import styled from 'styled-components';

export const ScrollContainer = styled.div`
  overflow: auto;
  max-height: 70vh;
`;
